import { TextField } from '@mui/material';

interface TeEndpointFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function TeEndpointField({
  value,
  error,
  setValue,
}: TeEndpointFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      label='Task Engine Endpoint'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default TeEndpointField;

